import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import DashboardLayout from 'src/layouts/dashboard/layout';
import { paths } from '../../paths';

// ----------------------------------------------------------------------

const FollowInstagramPage = lazy(() =>
  import('src/pages/dashboard/services/instagram-services/follow')
);

const LikeInstagramPage = lazy(() =>
  import('src/pages/dashboard/services/instagram-services/like')
);

const ViewInstagramPage = lazy(() =>
  import('src/pages/dashboard/services/instagram-services/view')
);

export const instagramRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: paths.instagram.root, element: <Navigate to={paths.instagram.follow} replace /> },
      { path: paths.instagram.follow, element: <FollowInstagramPage /> },
      { path: paths.instagram.like, element: <LikeInstagramPage /> },
      { path: paths.instagram.view, element: <ViewInstagramPage /> },
    ],
  },
];
